import React, {useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { ExportExcel } from "../../../components/ExportExcel/ExportExcel";

export function CustomTolbarExportStatement({ data }) {
  const [translatedData, setTranslatedData] = useState([]);
  useEffect(() => {
    const translatedDataTemp = data.map((item) => {
      return {
        id: item.id,
        cliente: item.customer,
        taxa: item.fee,
        instituicao: item.instituition,
        usuario: item.user,
        tipo: item.type,
        n_cupom: item.nsu,
        valor: item.value,
        taxa: item.fee,
        codigo_do_vendedor: item.seller_code,
        cpf_cnpj: item.cpf_cnpj,
        data: item.created_at,
      };
    });
    setTranslatedData(translatedDataTemp);
  }, [data]);

  return (
    <React.Fragment>
      <Tooltip title={"Exportar para Excel"}>
        <IconButton style={{marginTop:"-5px"}}>
          <ExportExcel excelData={data} fileName={"Download"} />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
}
